<template>
  <div id="document">
    <page-title
      title="Documenten en downloads"
      description="Overzicht van alle documenten die beschikbaar zijn in de app."
    ></page-title>
    <router-link to="/new-document/new" class="btn btn-success btn-lg mb-3">+ document toevoegen</router-link>
    <div id="document-table" v-if="documents.length">
      <table class="table table-hover">
        <thead class="thead-light">
          <tr>
            <th>map</th>
            <th>type</th>
            <th>datum</th>
            <th>Titel</th>
            <th>bestand</th>
            <th>status</th>
            <th>acties</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in documents" :key="item.id">
            <td>{{item.folder}}</td>
            <td>{{item.filename.substring(item.filename.length - 3)}}</td>
            <td>
              <DateFormat :date="item.dateCreated" day></DateFormat>
            </td>
            <td>{{item.title}}</td>
            <td>{{item.filename.substring(10)}}</td>
            <td>
              <button
                class="btn btn-sm btn-success"
                v-if="item.status=='live'"
                @click="toggleStatus(item)"
              >{{item.status == 'live' ? 'gepubliceerd' : 'concept'}}</button>
              <button
                class="btn btn-sm btn-warning"
                v-if="item.status!='live'"
                @click="toggleStatus(item)"
              >{{item.status}}</button>
            </td>
            <td>
              <router-link :to=" { name: 'new-document', params: {id: item.id, cid: cid} }">
                <Icon icon="pencil" title="aanpassen" success></Icon>
              </router-link>
              <Icon icon="trash" title="verwijder" v-on:clicked="deleteItem(index)" danger></Icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="!documents || !documents.length">Klik op de groene button om downloads toe te voegen.</div>
  </div>
</template>

<script>
const fb = require("@/firebaseConfig.js");
var firestorage = fb.firestorage;

import { mapState } from "vuex";
import PageTitle from "@/components/PageTitle.vue";
import DateFormat from "@/components/DateFormat.vue";
import Icon from "@/components/icon.vue";

export default {
  name: "Documents",
  components: {
    PageTitle,
    DateFormat,
    Icon
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  data() {
    return {
      documents: [],
      cid: this.$cookies.get("company")
    };
  },
  methods: {
    deleteItem(index) {
      this.$confirm({
        message: `Weet je zeker dat je dit item wilt verwijderen?`,
        button: {
          no: "annuleren",
          yes: "verwijderen"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          if (confirm) {
            // eerst de bestanden
            var file = this.documents[index].filename;
            if (file) {
              firestorage
                .ref("downloads/" + this.$cookies.get("company") + "/" + file)
                .delete()
                .catch(error => {
                  console.error(`file delete error occured: ${error}`);
                });
            }
            var id = this.documents[index].id;
            fb.companiesCollection
              .doc(this.$cookies.get("company"))
              .collection("downloads")
              .doc(id)
              .delete()
              .then(() => this.documents.splice(index, 1))
              .catch(function(e) {
                alert("Kon niet verwijderd worden");
                // TODO toast message
                console.log(e.message);
              });
          }
        }
      });
    },
    toggleStatus(item) {
      var status =
        item.status == "live"
          ? (item.status = "concept")
          : (item.status = "live");
      var id = item.id;
      fb.companiesCollection
        .doc(this.$cookies.get("company"))
        .collection("downloads")
        .doc(id)
        .update({ status: status })
        .then(() => (item.status = status))
        .catch(function(e) {
          alert("Kon niet aangepast worden");
          // TODO toast message
          console.log(e.message);
        });


      if (status !== "live") {
        return;
      }
      this.$confirm({
        message: `Wil je nu een automatische pushnotificatie sturen?`,
        button: {
          no: "overslaan",
          yes: "verzenden"
        },
        /**
         * Callback Function
         * @param {Boolean} confirm
         */
        callback: confirm => {
          var now = new Date();
          fb.notificationsCollection
            .add({
              type: "download",
              refid: id,
              date: now,
              created_by: this.$cookies.get("user"),
              title: item.title,
              message:
                "Er is een nieuw bestand beschikbaar. Je vindt dit in downloads.",
              establishments:item.establishments,
              positions:item.positions,
              hidden: true,
              company: this.$cookies.get("company"),
              sendPush: confirm
            })
            .catch(error => console.log(error));
        }
      });

    }
  },
  created() {
    //    fb.usersCollection.orderBy('lastname', 'asc').where('company', "==", this.$cookies.get('company')).get().then(querySnapshot => {

    fb.companiesCollection
      .doc(this.$cookies.get("company"))
      .collection("downloads")
      .orderBy("date_created", "desc")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          console.log(doc.id);
          let d = doc.data();
          const data = {
            id: doc.id,
            canComment: d.can_comment,
            dateCreated: d.date_created, // new Date(d.date_created),
            url: d.url,
            filename: d.filename,
            title: d.title,
            description: d.description,
            status: d.status,
            type: d.type, // TODO
            establishments: d.establishments,
            positions: d.positions,
            folder: d.folder
          };
          this.documents.push(data);
        });
      });
  }
};
</script>